module.exports = __webpack_public_path__ + "img/Event2.cc46f687.jpg";